export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvTable.vue?vue&type=template&id=0f087036&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvTable.vue?vue&type=template&id=0f087036&lang=pug&
// module id = 148
// module chunks = 0 1